export const ExtensionFunctionSchemaSvg = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="354"
    height="108"
    viewBox="0 0 354 108"
  >
    <defs>
      <rect id="extensions-function-a" width="354" height="108" rx="10" />
      <mask
        id="extensions-function-b"
        width="354"
        height="108"
        x="0"
        y="0"
        fill="#fff"
      >
        <use xlinkHref="#extensions-function-a" />
      </mask>
      <linearGradient id="extensions-function-c" x1="19.732%" y1="0%" y2="0%">
        <stop offset="0%" stopColor="#256BFF" />
        <stop offset="100%" stopColor="#3BC2FF" />
      </linearGradient>
    </defs>
    <g fill="none" fillRule="evenodd">
      <use
        fill="#D8D8D8"
        fillOpacity="0"
        stroke="#403E46"
        strokeDasharray="4 4"
        strokeWidth="2"
        mask="url(#extensions-function-b)"
        xlinkHref="#extensions-function-a"
      />
      <g transform="translate(75 30)">
        <g fill="#2F72FF" transform="translate(61 17.707)">
          <path
            fillRule="nonzero"
            d="M10,7.29289322 L14,7.29289322 L14,5.29289322 L10,5.29289322 L10,7.29289322 Z M18,7.29289322 L22,7.29289322 L22,5.29289322 L18,5.29289322 L18,7.29289322 Z M26,7.29289322 L30,7.29289322 L30,5.29289322 L26,5.29289322 L26,7.29289322 Z M34,7.29289322 L38,7.29289322 L38,5.29289322 L34,5.29289322 L34,7.29289322 Z M42,7.29289322 L46,7.29289322 L46,5.29289322 L42,5.29289322 L42,7.29289322 Z M50,7.29289322 L54,7.29289322 L54,5.29289322 L50,5.29289322 L50,7.29289322 Z M58,7.29289322 L62,7.29289322 L62,5.29289322 L58,5.29289322 L58,7.29289322 Z M66,7.29289322 L70,7.29289322 L70,5.29289322 L66,5.29289322 L66,7.29289322 Z"
          />
          <polygon
            points="68.707 3.414 77.293 2 75.879 10.586"
            transform="rotate(45 73 6.293)"
          />
          <polygon
            points="2.707 3.414 11.293 2 9.879 10.586"
            transform="scale(-1 1) rotate(45 0 -10.607)"
          />
        </g>
        <g fillRule="nonzero" transform="translate(0 2)">
          <path
            fill="#403E46"
            d="M32.0338274,0.000286093491 L31.9575393,0.000286093491 C27.9345213,0.0858800525 24.3032237,1.12137121 21.1018675,3.1075242 L20.6898308,3.36950601 C18.1047163,5.05376467 15.9844069,7.21352454 14.3416092,9.83346376 L14.09,10.244 L13.7250132,10.3175739 C10.0362072,11.1006594 6.90720159,12.8746314 4.39244204,15.6197881 C1.55698602,18.7150227 0.0878864852,22.536122 0.000385859111,26.9899551 C0.0880370427,31.7925261 1.76172126,35.8015381 4.991494,38.9808578 C8.20440796,42.143582 12.2154823,43.824507 16.9261208,43.998635 L49.4609375,44 C53.6080879,43.910491 57.0747915,42.4764345 59.7916713,39.7196577 C62.4984848,36.9730949 63.9101807,33.5416346 63.9995044,29.5299003 C63.9099268,25.5964839 62.586164,22.2935282 60.0508329,19.6275826 L59.7677453,19.3374256 C57.6719216,17.2438211 55.1401405,15.9031585 52.2192259,15.3318912 L52.015,15.294 L52.0041062,15.2524239 C50.8332057,11.0802909 48.5688516,7.57798989 45.2355252,4.79273791 C41.5202631,1.68834918 37.0940312,0.0858850742 32.0338274,0.000286093491 Z M32,2 C36.609375,2.07797271 40.59375,3.52046784 43.953125,6.32748538 C47.3125,9.13450292 49.4609375,12.7212476 50.3984375,17.0877193 C53.6796875,17.3996101 56.4140625,18.705653 58.6015625,21.005848 C60.7890625,23.3060429 61.921875,26.1325536 62,29.4853801 C61.921875,32.994152 60.7109375,35.9376218 58.3671875,38.3157895 C56.1102431,40.6058768 53.2737376,41.8294815 49.857671,41.9866035 L49.4609375,42 L17,42 C12.78125,41.8440546 9.24609375,40.3625731 6.39453125,37.5555556 C3.54296875,34.748538 2.078125,31.2397661 2,27.0292398 C2.078125,23.0526316 3.3671875,19.6998051 5.8671875,16.9707602 C8.3671875,14.2417154 11.53125,12.6042885 15.359375,12.0584795 C17,9.01754386 19.265625,6.60038986 22.15625,4.80701754 C25.046875,3.01364522 28.328125,2.07797271 32,2 Z"
          />
          <path
            fill="url(#extensions-function-c)"
            d="M31.5,11.5 C24.872583,11.5 19.5,16.872583 19.5,23.5 C19.5,30.127417 24.872583,35.5 31.5,35.5 C38.127417,35.5 43.5,30.127417 43.5,23.5 C43.5,16.872583 38.127417,11.5 31.5,11.5 Z M31.5,14.5 C36.4705627,14.5 40.5,18.5294373 40.5,23.5 C40.5,28.4705627 36.4705627,32.5 31.5,32.5 C26.5294373,32.5 22.5,28.4705627 22.5,23.5 C22.5,18.5294373 26.5294373,14.5 31.5,14.5 Z"
          />
        </g>
        <path
          fill="#403E46"
          fillRule="nonzero"
          d="M194,0 C199.522847,0 204,4.4771525 204,10 L204,38 C204,43.5228475 199.522847,48 194,48 L150,48 C144.477153,48 140,43.5228475 140,38 L140,10 C140,4.4771525 144.477153,0 150,0 L194,0 Z M194,2 L150,2 C145.665086,2 142.135457,5.44783777 142.003807,9.75082067 L142,10 L142,38 C142,42.3349143 145.447838,45.8645429 149.750821,45.9961932 L150,46 L194,46 C198.334914,46 201.864543,42.5521622 201.996193,38.2491793 L202,38 L202,10 C202,5.66508574 198.552162,2.13545713 194.249179,2.00380682 L194,2 Z M173.286067,15.7294722 L175.211491,16.2705278 L170.715398,32.2705278 L168.789973,31.7294722 L173.286067,15.7294722 Z M166.292893,17.2928932 L167.707107,18.7071068 L162.415,24 L167.707107,29.2928932 L166.292893,30.7071068 L159.585786,24 L166.292893,17.2928932 Z M177,17.2928932 L183.707107,24 L177,30.7071068 L175.585786,29.2928932 L180.877893,24 L175.585786,18.7071068 L177,17.2928932 Z"
        />
      </g>
    </g>
  </svg>
);

export const ExtensionWebhookSvg = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="354"
    height="108"
    viewBox="0 0 354 108"
  >
    <defs>
      <rect id="extensions-webhook-a" width="167" height="108" rx="10" />
      <mask
        id="extensions-webhook-c"
        width="167"
        height="108"
        x="0"
        y="0"
        fill="#fff"
      >
        <use xlinkHref="#extensions-webhook-a" />
      </mask>
      <rect
        id="extensions-webhook-b"
        width="167"
        height="108"
        x="187"
        rx="10"
      />
      <mask
        id="extensions-webhook-d"
        width="167"
        height="108"
        x="0"
        y="0"
        fill="#fff"
      >
        <use xlinkHref="#extensions-webhook-b" />
      </mask>
      <linearGradient id="extensions-webhook-e" x1="19.732%" y1="0%" y2="0%">
        <stop offset="0%" stopColor="#256BFF" />
        <stop offset="100%" stopColor="#3BC2FF" />
      </linearGradient>
    </defs>
    <g fill="none" fillRule="evenodd">
      <use
        fill="#D8D8D8"
        fillOpacity="0"
        stroke="#403E46"
        strokeDasharray="4 4"
        strokeWidth="2"
        mask="url(#extensions-webhook-c)"
        xlinkHref="#extensions-webhook-a"
      />
      <use
        fill="#D8D8D8"
        fillOpacity="0"
        stroke="#403E46"
        strokeDasharray="4 4"
        strokeWidth="2"
        mask="url(#extensions-webhook-d)"
        xlinkHref="#extensions-webhook-b"
      />
      <g transform="translate(112 26)">
        <g transform="translate(127)">
          <path
            fill="#403E46"
            fillRule="nonzero"
            d="M60,40 C62.209139,40 64,41.790861 64,44 L64,52 C64,54.209139 62.209139,56 60,56 L4,56 C1.790861,56 0,54.209139 0,52 L0,44 C0,41.790861 1.790861,40 4,40 L60,40 Z M60,42 L4,42 C2.9456382,42 2.08183488,42.8158778 2.00548574,43.8507377 L2,44 L2,52 C2,53.0543618 2.81587779,53.9181651 3.85073766,53.9945143 L4,54 L60,54 C61.0543618,54 61.9181651,53.1841222 61.9945143,52.1492623 L62,52 L62,44 C62,42.9456382 61.1841222,42.0818349 60.1492623,42.0054857 L60,42 Z M8,46 C9.1045695,46 10,46.8954305 10,48 C10,49.1045695 9.1045695,50 8,50 C6.8954305,50 6,49.1045695 6,48 C6,46.8954305 6.8954305,46 8,46 Z M16,46 C17.1045695,46 18,46.8954305 18,48 C18,49.1045695 17.1045695,50 16,50 C14.8954305,50 14,49.1045695 14,48 C14,46.8954305 14.8954305,46 16,46 Z M57,47 C57.5522847,47 58,47.4477153 58,48 C58,48.5522847 57.5522847,49 57,49 L31,49 C30.4477153,49 30,48.5522847 30,48 C30,47.4477153 30.4477153,47 31,47 L57,47 Z M60,20 C62.209139,20 64,21.790861 64,24 L64,32 C64,34.209139 62.209139,36 60,36 L4,36 C1.790861,36 0,34.209139 0,32 L0,24 C0,21.790861 1.790861,20 4,20 L60,20 Z M60,22 L4,22 C2.9456382,22 2.08183488,22.8158778 2.00548574,23.8507377 L2,24 L2,32 C2,33.0543618 2.81587779,33.9181651 3.85073766,33.9945143 L4,34 L60,34 C61.0543618,34 61.9181651,33.1841222 61.9945143,32.1492623 L62,32 L62,24 C62,22.9456382 61.1841222,22.0818349 60.1492623,22.0054857 L60,22 Z M8,26 C9.1045695,26 10,26.8954305 10,28 C10,29.1045695 9.1045695,30 8,30 C6.8954305,30 6,29.1045695 6,28 C6,26.8954305 6.8954305,26 8,26 Z M16,26 C17.1045695,26 18,26.8954305 18,28 C18,29.1045695 17.1045695,30 16,30 C14.8954305,30 14,29.1045695 14,28 C14,26.8954305 14.8954305,26 16,26 Z M57,27 C57.5522847,27 58,27.4477153 58,28 C58,28.5522847 57.5522847,29 57,29 L31,29 C30.4477153,29 30,28.5522847 30,28 C30,27.4477153 30.4477153,27 31,27 L57,27 Z M60,0 C62.209139,0 64,1.790861 64,4 L64,12 C64,14.209139 62.209139,16 60,16 L4,16 C1.790861,16 0,14.209139 0,12 L0,4 C0,1.790861 1.790861,0 4,0 L60,0 Z M60,2 L4,2 C2.9456382,2 2.08183488,2.81587779 2.00548574,3.85073766 L2,4 L2,12 C2,13.0543618 2.81587779,13.9181651 3.85073766,13.9945143 L4,14 L60,14 C61.0543618,14 61.9181651,13.1841222 61.9945143,12.1492623 L62,12 L62,4 C62,2.9456382 61.1841222,2.08183488 60.1492623,2.00548574 L60,2 Z M8,6 C9.1045695,6 10,6.8954305 10,8 C10,9.1045695 9.1045695,10 8,10 C6.8954305,10 6,9.1045695 6,8 C6,6.8954305 6.8954305,6 8,6 Z M16,6 C17.1045695,6 18,6.8954305 18,8 C18,9.1045695 17.1045695,10 16,10 C14.8954305,10 14,9.1045695 14,8 C14,6.8954305 14.8954305,6 16,6 Z M57,7 C57.5522847,7 58,7.44771525 58,8 C58,8.55228475 57.5522847,9 57,9 L31,9 C30.4477153,9 30,8.55228475 30,8 C30,7.44771525 30.4477153,7 31,7 L57,7 Z"
          />
        </g>
        <path
          fill="#2F72FF"
          fillRule="nonzero"
          d="M10,29 L14,29 L14,27 L10,27 L10,29 Z M18,29 L22,29 L22,27 L18,27 L18,29 Z M26,29 L30,29 L30,27 L26,27 L26,29 Z M34,29 L38,29 L38,27 L34,27 L34,29 Z M42,29 L46,29 L46,27 L42,27 L42,29 Z M50,29 L54,29 L54,27 L50,27 L50,29 Z M58,29 L62,29 L62,27 L58,27 L58,29 Z M66,29 L70,29 L70,27 L66,27 L66,29 Z M74,29 L78,29 L78,27 L74,27 L74,29 Z M82,29 L86,29 L86,27 L82,27 L82,29 Z M90,29 L94,29 L94,27 L90,27 L90,29 Z M98,29 L102,29 L102,27 L98,27 L98,29 Z M106,29 L110,29 L110,27 L106,27 L106,29 Z M114,29 L118,29 L118,27 L114,27 L114,29 Z"
        />
        <polygon
          fill="#2F72FF"
          points="116.707 25.121 125.293 23.707 123.879 32.293"
          transform="rotate(45 121 28)"
        />
        <polygon
          fill="#2F72FF"
          points="2.707 25.121 11.293 23.707 9.879 32.293"
          transform="scale(-1 1) rotate(45 0 11.1)"
        />
      </g>
      <g fillRule="nonzero" transform="translate(51 32)">
        <path
          fill="#403E46"
          d="M32.0338274,0.000286093491 L31.9575393,0.000286093491 C27.9345213,0.0858800525 24.3032237,1.12137121 21.1018675,3.1075242 L20.6898308,3.36950601 C18.1047163,5.05376467 15.9844069,7.21352454 14.3416092,9.83346376 L14.09,10.244 L13.7250132,10.3175739 C10.0362072,11.1006594 6.90720159,12.8746314 4.39244204,15.6197881 C1.55698602,18.7150227 0.0878864852,22.536122 0.000385859111,26.9899551 C0.0880370427,31.7925261 1.76172126,35.8015381 4.991494,38.9808578 C8.20440796,42.143582 12.2154823,43.824507 16.9261208,43.998635 L49.4609375,44 C53.6080879,43.910491 57.0747915,42.4764345 59.7916713,39.7196577 C62.4984848,36.9730949 63.9101807,33.5416346 63.9995044,29.5299003 C63.9099268,25.5964839 62.586164,22.2935282 60.0508329,19.6275826 L59.7677453,19.3374256 C57.6719216,17.2438211 55.1401405,15.9031585 52.2192259,15.3318912 L52.015,15.294 L52.0041062,15.2524239 C50.8332057,11.0802909 48.5688516,7.57798989 45.2355252,4.79273791 C41.5202631,1.68834918 37.0940312,0.0858850742 32.0338274,0.000286093491 Z M32,2 C36.609375,2.07797271 40.59375,3.52046784 43.953125,6.32748538 C47.3125,9.13450292 49.4609375,12.7212476 50.3984375,17.0877193 C53.6796875,17.3996101 56.4140625,18.705653 58.6015625,21.005848 C60.7890625,23.3060429 61.921875,26.1325536 62,29.4853801 C61.921875,32.994152 60.7109375,35.9376218 58.3671875,38.3157895 C56.1102431,40.6058768 53.2737376,41.8294815 49.857671,41.9866035 L49.4609375,42 L17,42 C12.78125,41.8440546 9.24609375,40.3625731 6.39453125,37.5555556 C3.54296875,34.748538 2.078125,31.2397661 2,27.0292398 C2.078125,23.0526316 3.3671875,19.6998051 5.8671875,16.9707602 C8.3671875,14.2417154 11.53125,12.6042885 15.359375,12.0584795 C17,9.01754386 19.265625,6.60038986 22.15625,4.80701754 C25.046875,3.01364522 28.328125,2.07797271 32,2 Z"
        />
        <path
          fill="url(#extensions-webhook-e)"
          d="M31.5,11.5 C24.872583,11.5 19.5,16.872583 19.5,23.5 C19.5,30.127417 24.872583,35.5 31.5,35.5 C38.127417,35.5 43.5,30.127417 43.5,23.5 C43.5,16.872583 38.127417,11.5 31.5,11.5 Z M31.5,14.5 C36.4705627,14.5 40.5,18.5294373 40.5,23.5 C40.5,28.4705627 36.4705627,32.5 31.5,32.5 C26.5294373,32.5 22.5,28.4705627 22.5,23.5 C22.5,18.5294373 26.5294373,14.5 31.5,14.5 Z"
        />
      </g>
    </g>
  </svg>
);
